import React, { Component } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field } from "formik";
import { getFieldStatus } from "./common";
import { AddPropertyFieldComponent } from "../property/PropertyField";

import Input from "@material-ui/core/Input";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

class SelectChipFieldInner extends Component {
  constructor(props) {
    super(props);
    this.inputLabel = React.createRef();
  }

  state = {
    options: typeof this.props.options !== "function" ? this.props.options : [],
    labelWidth: 0
  };

  getOptions = () => {
    if (!this.props.options || typeof this.props.options !== "function") return;

    const opts = this.props.options(this.props.form.values);

    if (opts && opts.then) opts.then(options => this.setState({ options }));
    else this.setState({ options: opts });
  };

  setLabelWidth = () => {
    // eslint-disable-next-line react/no-did-update-set-state
    if (this.inputLabel.current.offsetWidth !== this.state.labelWidth)
      this.setState({ labelWidth: this.inputLabel.current.offsetWidth });
  };

  componentDidMount = () => {
    this.getOptions();
    this.setLabelWidth();
  };

  componentDidUpdate = prevProps => {
    if (prevProps.form.values !== this.props.form.values) this.getOptions();
    this.setLabelWidth();
  };

  render = () => {
    const {
      classes,
      name,
      label: labelProp = name,
      field,
      form,
      variant,
      margin,
      required,
      fullWidth = true,
      checkboxes = true,
      disabled: disabledProp,
      value: valueProp
    } = this.props;

    const { disabled, label, value } = getFieldStatus(
      form,
      field,
      valueProp,
      labelProp,
      disabledProp
    );

    const fieldVal = value === undefined || value === null ? [] : value;

    return (
      <FormControl
        fullWidth={fullWidth}
        margin={margin}
        required={required}
        variant={variant}
        className={classes.formControl}
      >
        <InputLabel ref={this.inputLabel} variant={variant} htmlFor={name}>
          {label}
        </InputLabel>
        <Select
          disabled={disabled}
          multiple
          value={fieldVal}
          onChange={field.onChange}
          onBlur={field.onBlur}
          input={
            variant === "outlined" ? (
              <OutlinedInput
                id={name}
                name={name}
                labelWidth={this.state.labelWidth}
              />
            ) : (
              <Input id={name} name={name} />
            )
          }
          renderValue={selected => (
            <div className={classes.chips}>
              {selected &&
                selected.map(o => {
                  return (
                    <Chip
                      key={"chip-" + o}
                      label={o}
                      className={classes.chip}
                    />
                  );
                })}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {this.state.options.map(option => (
            <MenuItem key={"menuItem-" + option} value={option}>
              {checkboxes ? (
                <>
                  <Checkbox checked={fieldVal.includes(option)} />
                  <ListItemText primary={option} />
                </>
              ) : (
                option
              )}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };
}

const SelectChipField = withStyles(
  {
    formControl: {
      maxWidth: "100%"
    },
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    chip: {
      margin: 2
    }
  },
  { name: "LcSelectChipField" }
)(
  ({
    name,
    fast = true,
    FieldComponent = fast ? FastField : Field,
    ...props
  }) => (
    <FieldComponent name={name}>
      {({ field, form }) => (
        <SelectChipFieldInner
          field={field}
          form={form}
          name={name}
          {...props}
        />
      )}
    </FieldComponent>
  )
);

AddPropertyFieldComponent("selectchip", SelectChipField);

export default SelectChipField;
